import {Box, Flex, FormLabel, Stack} from '@chakra-ui/react';
import React, {useState, useMemo} from 'react';
import {get, queryStringBuilder} from '../../service/ApiService';
import ErrorHelper from '../../service/ErrorHelper';
import Select from 'react-select';
import {useQuery} from 'react-query';

export default function EmployeeSelect({oppId, setEmployeeId, width = 600}) {
  const [toast, setToast] = useState('');

  const url = useMemo(() => queryStringBuilder('/OpportunityPlan/' + oppId + '/employees', {Page: 1, PageSize: 9999}), [oppId]);

  const {data, isLoading} = useQuery(['employee', oppId], () => get(url), {
    onError: () => {
      setToast({error: 'Error loading employees'});
    },
  });

  const employees =
    data?.data?.map(employee => ({
      value: employee?.id,
      label: `${employee.emCode} | ${employee.emName} | ${employee.emDept}`,
    })) ?? [];

  return (
    <Stack spacing={0.5}>
      <FormLabel fontSize="sm" mb={0}>
        Select Employee
      </FormLabel>
      <Box width={width} textAlign="left">
        <Select onChange={val => setEmployeeId(val?.value)} options={employees} isDisabled={employees.length <= 0 || isLoading} />
      </Box>
      <ErrorHelper toastResponse={toast} />
    </Stack>
  );
}
